import {
  AUTH_STATE,
  NAME_FIELD,
  EMAIL_FIELD,
  ADMIN_FIELD,
  TOKEN_FIELD,
  USERNAME_FIELD,
} from '../constants';

function writeToLocalStorage(data) {
  const fields = [
    USERNAME_FIELD,
    EMAIL_FIELD,
    TOKEN_FIELD,
    ADMIN_FIELD
  ];

  const authState = {};

  fields.forEach(field => {
    if (data[field]) {
      authState[field] = data[field];
    }
  });

  localStorage.setItem(AUTH_STATE, JSON.stringify(authState));

  return authState;
}

export default writeToLocalStorage;
